import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import homeStyles from "../styles/platform-home.css?url";
import { marketingMedia } from "../../src/lib/marketing-media";
import type { StructuredData } from "../../src/lib/structured-data";
import { withStylesheet } from "../lib/head";
import { FeaturePage } from "../platform/feature-page";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { loadFeaturePage } from "../platform/product-pages";

/**
 * A feature's own page, /features/<slug> (Drate's host only); a 404 on creator sites. A page folded
 * into another (/features/app) sends its visitors there for good.
 */
export const Route = createFileRoute("/features/$slug")({
  loader: async ({ params }) => {
    const page = await loadFeaturePage({ data: params.slug });
    if (!page) throw notFound();
    if (page.kind === "redirect") throw redirect({ href: page.to, statusCode: 301 });
    return page;
  },
  head: ({ matches, loaderData: page }) => {
    if (!page) return {};
    return withStylesheet(
      platformPageHead(platformShellFrom(matches), {
        pathname: `/features/${page.slug}`,
        title: page.title,
        description: page.description,
        canonicalPath: `/features/${page.slug}`,
        image: page.image ? marketingMedia(page.image) : undefined,
        structuredData: JSON.parse(page.structuredData) as StructuredData,
      }),
      homeStyles,
    );
  },
  component: () => <FeaturePage slug={Route.useLoaderData().slug} />,
});
